(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitter-network"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fitter-network')) {
    class FitterNetwork extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.search = this.querySelector('[data-fitter-search]');
        this.state = this.querySelector('[data-fitter-state]');
        this.results = this.querySelector('[data-fitter-results]');
        this.empty = this.querySelector('[data-fitter-empty]');
        this.clear = this.querySelector('[data-fitter-clear]');
        this.cards = Array.from(this.querySelectorAll('[data-fitter-card]'));
        this.pins = Array.from(this.querySelectorAll('[data-fitter-pin]'));
        this.mapElement = this.querySelector('[data-fitter-map]');
        this.mapCanvas = this.querySelector('[data-fitter-map-canvas]');
        this.mapMessage = this.querySelector('[data-fitter-map-message]');
        this.markers = new Map();
        this.search?.addEventListener('input', () => this.filterFitters());
        this.state?.addEventListener('change', () => this.filterFitters());
        this.clear?.addEventListener('click', () => this.clearFilters());
        this.pins.forEach((pin) => pin.addEventListener('click', () => this.selectFitter(pin.dataset.fitterId, true)));
        this.cards.forEach((card) => card.addEventListener('pointerenter', () => this.selectFitter(card.dataset.fitterId, false)));
        this.filterFitters();
        this.initializeMap().then(() => {
          this.handleHashAnchor();
        });
        window.addEventListener('hashchange', () => this.handleHashAnchor());
      }

      handleHashAnchor() {
        if (!window.location.hash) return;
        try {
          const target = this.querySelector(window.location.hash);
          if (target && target.dataset.fitterId) {
            this.selectFitter(target.dataset.fitterId, true);
          }
        } catch (e) {
          // Ignore invalid hash selectors
        }
      }

      async initializeMap() {
        const apiKey = this.mapElement?.dataset.googleMapsApiKey;
        if (!this.mapCanvas || !apiKey) {
          this.showMapError();
          return;
        }

        try {
          await this.loadGoogleMaps(apiKey);
          const { Map: GoogleMap } = await google.maps.importLibrary('maps');
          const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
          this.map = new GoogleMap(this.mapCanvas, {
            center: { lat: -28.5, lng: 139.5 },
            zoom: 4,
            mapId: this.mapElement.dataset.googleMapsMapId || 'DEMO_MAP_ID',
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true,
            clickableIcons: false,
            gestureHandling: 'cooperative'
          });

          this.pins.forEach((pin) => {
            const latitude = Number.parseFloat(pin.dataset.fitterLatitude);
            const longitude = Number.parseFloat(pin.dataset.fitterLongitude);
            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
            pin.hidden = false;
            const marker = new AdvancedMarkerElement({
              map: this.map,
              position: { lat: latitude, lng: longitude },
              content: pin,
              title: pin.getAttribute('aria-label') || ''
            });
            this.markers.set(pin.dataset.fitterId, marker);
          });

          this.filterFitters();
        } catch (error) {
          this.showMapError();
        }
      }

      loadGoogleMaps(apiKey) {
        if (window.google?.maps?.importLibrary) return Promise.resolve();
        if (window.tghGoogleMapsPromise) return window.tghGoogleMapsPromise;

        window.tghGoogleMapsPromise = new Promise((resolve, reject) => {
          const callbackName = 'tghGoogleMapsReady';
          window[callbackName] = () => {
            delete window[callbackName];
            resolve();
          };
          const script = document.createElement('script');
          script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&loading=async&libraries=marker&callback=${callbackName}`;
          script.async = true;
          script.onerror = reject;
          document.head.appendChild(script);
        });

        return window.tghGoogleMapsPromise;
      }

      showMapError() {
        if (!this.mapMessage) return;
        this.mapMessage.textContent = this.mapElement?.dataset.mapError || '';
        this.mapMessage.hidden = false;
      }

      fitVisibleMarkers() {
        if (!this.map || !window.google?.maps || this.markers.size === 0) return;
        const visibleMarkers = this.cards
          .filter((card) => !card.hidden)
          .map((card) => this.markers.get(card.dataset.fitterId))
          .filter(Boolean);
        if (visibleMarkers.length === 0) return;
        if (visibleMarkers.length === 1) {
          this.map.setCenter(visibleMarkers[0].position);
          this.map.setZoom(9);
          return;
        }
        const bounds = new google.maps.LatLngBounds();
        visibleMarkers.forEach((marker) => bounds.extend(marker.position));
        this.map.fitBounds(bounds, 70);
      }

      filterFitters() {
        const query = this.search?.value.trim().toLowerCase() || '';
        const state = this.state?.value || '';
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const matchesQuery = !query || card.dataset.fitterSearchValue.includes(query);
          const matchesState = !state || card.dataset.fitterState === state;
          const visible = matchesQuery && matchesState;
          card.hidden = !visible;
          const pin = this.pins.find((item) => item.dataset.fitterId === card.dataset.fitterId);
          const marker = this.markers.get(card.dataset.fitterId);
          if (pin && !marker) pin.hidden = true;
          if (marker) marker.map = visible ? this.map : null;
          if (visible) visibleCount += 1;
        });

        if (this.empty) this.empty.hidden = visibleCount !== 0 || this.cards.length === 0;
        if (this.results) {
          const template = visibleCount === 1 ? this.dataset.resultsSingular : this.dataset.resultsPlural;
          this.results.textContent = template.replace('[count]', visibleCount);
        }
        this.fitVisibleMarkers();
      }

      selectFitter(id, moveFocus) {
        this.cards.forEach((card) => card.classList.toggle('is-active', card.dataset.fitterId === id));
        this.pins.forEach((pin) => pin.classList.toggle('is-active', pin.dataset.fitterId === id));
        const card = this.cards.find((item) => item.dataset.fitterId === id);
        const marker = this.markers.get(id);
        if (marker && this.map) {
          this.map.panTo(marker.position);
          if (this.map.getZoom() < 8) this.map.setZoom(9);
        }
        if (card && moveFocus) {
          card.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
          card.focus({ preventScroll: true });
        }
      }

      clearFilters() {
        if (this.search) this.search.value = '';
        if (this.state) this.state.value = '';
        this.filterFitters();
        this.search?.focus();
      }
    }

    customElements.define('fitter-network', FitterNetwork);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
